export enum DateField {
    Month = 'MONTH',
    Day = 'DAY',
    Year = 'YEAR'
}
